import application_settings from "../applicationSettings";
import Event from "./Event";
import modules from "../modules";

class UploadMediaReview extends Event {
  eventName = "oms_uploadMediaReview";

  constructor() {
    super();
    this.add();
  }

  generateUUID() {
    return window.crypto.randomUUID();
  }

  /**
   * Split a file into chunks
   * @param {File} file
   * @param {number} chunkSize in bytes (default 2MB)
   * @returns {Blob[]}
   */
  chunkFile(file, chunkSize) {
    const chunks = [];
    let offset = 0;
    while (offset < file.size) {
      const chunk = file.slice(offset, offset + chunkSize);
      chunks.push(chunk);
      offset += chunkSize;
    }
    return chunks;
  }

  uploadChunk(
    {
      chunk,
      chunkIndex,
      totalChunks,
      fileName,
      payload,
      dzuuid,
      totalFileSize,
      chunkSize,
    },
    onSuccess,
    onError
  ) {
    const formData = new FormData();
    const chunkByteOffset = (chunkIndex - 1) * chunkSize;

    formData.append("file", chunk, fileName);
    formData.append("dzchunkindex", chunkIndex);
    formData.append("dztotalchunkcount", totalChunks);
    formData.append("imageType", payload.imageType);
    formData.append("dzuuid", dzuuid);
    formData.append("dztotalfilesize", totalFileSize);
    formData.append("dzchunksize", chunk.size);
    formData.append("dzchunkbyteoffset", chunkByteOffset);

    const request = new modules.Request();
    request.send({
      endPoint: application_settings.endPoints.uploadMediaReview,
      method: "POST",
      data: formData,
      contentType: false,
      processData: false,
      authenticate: true,
      client_id: payload.client_id,
      canUsePublicAuth: false,
      onSuccess,
      onError,
    });
  }

  eventFunction(data) {
    const payload = data.detail ? data.detail : data;
    const { file, client_id, imageType } = payload;
    const thisObj = this;
    const requestId = payload.request_id || "";
    const action = payload.action || "";

    if (!file) {
      thisObj.onErrorEvent(
        { message: "file is required", status: 422 },
        { action, request_id: requestId }
      );
      return;
    }

    if (file.size <= 2 * 1024 * 1024) {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("imageType", imageType);

      const request = new modules.Request();
      request.send({
        endPoint: application_settings.endPoints.uploadMediaReview,
        method: "POST",
        data: formData,
        contentType: false,
        processData: false,
        authenticate: true,
        client_id,
        canUsePublicAuth: false,
        onSuccess: (response) => {
          const fileData = response?.data || {};
          thisObj.onSuccessEvent(
            {
              success: fileData.success,
              path: fileData.data.path,
              name: fileData.data.name,
              size: fileData.data.size,
            },
            { action, request_id: requestId }
          );
        },
        onError: (error) => {
          thisObj.onErrorEvent(
            {
              message: error.message || "Upload failed",
              status: error.status || 500,
            },
            { action, request_id: requestId }
          );
        },
      });

      return;
    }

    const dzuuid = this.generateUUID();
    const chunkSize = 2 * 1024 * 1024;
    const chunks = this.chunkFile(file, chunkSize);
    const totalChunks = chunks.length;
    let currentChunk = 0;

    const uploadNextChunk = () => {
      thisObj.uploadChunk(
        {
          chunk: chunks[currentChunk],
          chunkIndex: currentChunk,
          totalChunks,
          fileName: file.name,
          payload,
          dzuuid,
          totalFileSize: file.size,
          chunkSize,
        },
        (response) => {
          if (response?.data?.done) {
            thisObj.onSuccessEvent(
              {
                success: true,
                done: response?.data?.done
              },
              { action, request_id: requestId }
            ); 
          } else {
            const fileData = response?.data || {};
            thisObj.onSuccessEvent(
              {
                success: fileData.success,
                path: fileData.data.path,
                name: fileData.data.name,
                size: fileData.data.size,
              },
              { action, request_id: requestId }
            );
          }

          currentChunk++;
          if (currentChunk < totalChunks) {
            uploadNextChunk();
          }
        },
        (error) => {
          thisObj.onErrorEvent(
            {
              message: error.message || "Chunk upload failed",
              status: error.status || 500,
            },
            { action, request_id: requestId }
          );
        }
      );
    };

    uploadNextChunk();
  }
}

export default UploadMediaReview;
